import React from 'react';
import map from "../../assets/img/map-dark.svg";

// Map location data
const locations = [
    { title: 'Canada', top: '29%', left: '15.5%' },
    { title: 'United States', top: '42%', left: '20%' },
    { title: 'Brazil', top: '70%', left: '32%' },
    { title: 'Nigeria', top: '57%', left: '48%' },
    { title: 'Finland', top: '18%', left: '53%' },
    { title: 'Ukraine', top: '34%', left: '55%' },
    { title: 'India', top: '45%', left: '68%' },
    { title: 'China', top: '35%', left: '80%' },
    { title: 'Australia', top: '77%', left: '85%' }
];



const NetworkMapSection = () => {
    return (
        <section className="network-map-section ptb-100 gray-light-bg">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-9 col-lg-6">
                        <div className="section-heading text-center mb-5">
                            <h2>Our Data centers Location</h2>
                            <p>
                                Cloudhub offers a low latency worldwide network, enabling you to deploy your service infrastructure in close proximity to your customer base.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="network-map-wrap">
                            <ul className="custom-map-location">
                                {locations.map((location, index) => (
                                    <li
                                        key={index}
                                        style={{ top: location.top, left: location.left }}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={location.title}
                                    >
                                        <span></span>
                                    </li>
                                ))}
                            </ul>
                            <img src={map} alt="location map" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NetworkMapSection;
